import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{!--\n  DEPRECATED\n  Use design-system-kit Toast component instead\n  This component lives here only to support FlashMessages::Stack storybook page\n--}}\n\n<div>\n  {{@content.message}}\n</div>", {
  moduleName: "@qonto/ui-kit/components/flash-messages/deprecated-toast.hbs"
});